<template>
  <div>
    <nav-bar title="注册协议"></nav-bar>
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    >
    </quill-editor>
    <div class="btn">
      <span>同意协议代表用户签订电子协议，合同实时生效</span>
      <van-button block>同意协议</van-button>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { Button } from "vant";

export default {
  name: "signProtocol",
  data() {
    return {
      content: ""
    };
  },
  components: {
    NavBar,
    "van-button": Button
  },
  methods: {
    onEditorBlur() {
      console.log("blur", this.content);
    },

    onEditorFocus() {
      console.log("focus", this.content);
    },

    onEditorReady() {
      console.log("ready", this.content);
    }
  }
};
</script>

<style scoped lang="less">
.btn {
  width: 100%;
  padding: 16px 0;
  background: rgba(255, 255, 255, 1);
  text-align: center;
  position: absolute;
  bottom: 0;
  span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(98, 104, 112, 1);
    display: block;
    margin-bottom: 16px;
  }
  .van-button {
    width: 325px;
    height: 44px;
    background: rgba(33, 37, 41, 1);
    border-radius: 6px;
    margin: 0 auto;
  }
}
</style>
